module.exports = __webpack_public_path__ + "static/media/symbol.fa42f50b.svg";